addEventListener('DOMContentLoaded', (event) => {
    (function () {
        let errorMsg = document.querySelector('#error_smp-cta-bar_signup');
        if(errorMsg) {
            errorMsg.remove();
        }
    })();
});



   



